import { NavLink } from "react-router-dom";
import Faq from "./faq";
import { useEffect } from "react";
import { CONTACT_CONFIG } from '../config/contact';

export default function Privacy() {
  // Utilisation des variables de configuration centralisées
  const contactInfo = CONTACT_CONFIG;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      {/* Header Section */}
      <section className="bg-gradient-to-r from-[#00d4ff] to-[#090979] text-white py-8">
        <div className="h-[25vh]"></div>
        <div className="main-content">
          {/* Main Title */}
          <div className="text-center">
            <h1 className="text-4xl font-bold">Politique de Confidentialité</h1>
          </div>
          {/* Navigation Breadcrumbs */}
          <div className="text-center mb-4">
            <span className="text-sm">
              <NavLink
                to="/"
                className="transition-all duration-500 hover:text-[#090979]"
                onClick={scrollToTop}
              >
                Accueil
              </NavLink>{" "}
              /{" "}
              <span className="text-gray-300">
                Politique de Confidentialité
              </span>
            </span>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="bg-slate-50 text-[#1B1B1B] py-12 min-h-[80vh]">
        <div className="main-content w-[85%] m-auto">
          <div className="space-y-8">
            {/* Section 1 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                1. Informations que nous collectons
              </h2>
              <p className="text-base leading-relaxed">
                Nous collectons les informations que vous nous fournissez
                directement, comme votre nom, adresse e-mail et informations de
                paiement lorsque vous vous abonnez à nos services IPTV. Ces
                informations sont nécessaires pour fournir nos services et
                traiter vos paiements.
              </p>
            </div>

            {/* Section 2 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                2. Comment nous utilisons vos informations
              </h2>
              <p className="text-base leading-relaxed">
                Nous utilisons vos informations pour fournir, maintenir et
                améliorer nos services IPTV, traiter vos paiements, communiquer
                avec vous concernant votre compte et vous envoyer des mises à
                jour importantes sur nos services.
              </p>
            </div>

            {/* Section 3 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                3. Partage de vos informations
              </h2>
              <p className="text-base leading-relaxed">
                Nous ne vendons, n'échangeons ni ne louons vos informations
                personnelles à des tiers. Nous pouvons partager vos informations
                uniquement avec nos fournisseurs de services de paiement pour
                traiter vos transactions, et seulement dans la mesure
                nécessaire.
              </p>
            </div>

            {/* Section 4 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                4. Sécurité de vos données
              </h2>
              <p className="text-base leading-relaxed">
                Nous mettons en place des mesures de sécurité appropriées pour
                protéger vos informations personnelles contre l'accès non
                autorisé, la modification, la divulgation ou la destruction. Vos
                données sont chiffrées et stockées de manière sécurisée.
              </p>
            </div>

            {/* Section 5 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">5. Vos droits</h2>
              <p className="text-base leading-relaxed">
                Vous avez le droit d'accéder, de corriger ou de supprimer vos
                informations personnelles à tout moment. Vous pouvez également
                vous opposer au traitement de vos données ou demander la
                portabilité de vos informations.
              </p>
            </div>

            {/* Section 6 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">6. Contactez-nous</h2>
              <p className="text-base leading-relaxed mb-4">
                Pour toute question sur cette politique de confidentialité ou
                pour exercer vos droits, vous pouvez nous contacter via :
              </p>
              <ul className="list-disc list-inside space-y-2 text-base">
                <li>Email : {contactInfo.email}</li>
                <li>
                  WhatsApp :{" "}
                  <a
                    href={contactInfo.whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline hover:text-blue-800"
                  >
                    Cliquez ici pour nous contacter
                  </a>
                </li>
              </ul>
            </div>

            {/* Conclusion */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-base leading-relaxed">
                Merci d'avoir choisi {contactInfo.companyName}. Nous sommes fiers de garantir
                votre confidentialité et de vous offrir un service de haute
                qualité sans compromettre votre sécurité ou votre anonymat.
              </p>
            </div>
          </div>
        </div>
        <Faq />
      </section>
    </>
  );
}
